export default "__VITE_ASSET__CE8vHqH0__"